/* eslint-disable @typescript-eslint/promise-function-async */
import { NgModule } from '@angular/core'

import { RouterModule, type Routes } from '@angular/router'
import { NotFoundComponent } from './components/pages/not-found/not-found.component'
import { authGuard } from './guards/auth.guard'
import { rolGuardMonitorist } from './guards/rol-monit.guard'
import { rolGuardAdmin } from './guards/rol-admin.guard'
import { rolGuardClient } from './guards/rol-client.guard'
import { loginGuard } from './guards/login.guard'

const routes: Routes = [
  { path: '', redirectTo: 'client', pathMatch: 'full' },
  {
    path: 'auth',
    loadChildren: () => import('./components/pages/auth/auth-routing.module').then((m) => m.AuthRoutingModule),
    canActivate:[loginGuard]
  },
  {
    path: 'client',
    loadChildren: () => import('./components/pages/client/client-routing.module').then((m) => m.ClientRoutingModule),
    canActivate:[authGuard, rolGuardClient],
  },
  {
    path: 'admin',
    loadChildren: () => import('./components/pages/admin/admin-routing.module').then((m) => m.AdminRoutingModule),
    canActivate:[authGuard, rolGuardAdmin]
  },
  {
    path: 'monitorist',
    loadChildren: () => import('./components/pages/monitorist/monitorist-routing.module').then((m) => m.MonitoristRoutingModule),
    canActivate:[authGuard, rolGuardMonitorist]
  },
  {
    path: '**',
    component: NotFoundComponent
  }

]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
